import { useState, useEffect } from "react";

export default function LogoIntro() {
  const [phase, setPhase] = useState("idle"); // idle | in | hold | out | done

  useEffect(() => {
    if (sessionStorage.getItem("hb_intro_shown")) {
      setPhase("done");
      return;
    }

    // Slight delay so browser paints first
    const t0 = setTimeout(() => setPhase("in"), 50);
    // Start fade-out after logo is visible for ~1.3s
    const t1 = setTimeout(() => setPhase("out"), 1800);
    // Remove from DOM after fade-out completes (600ms)
    const t2 = setTimeout(() => {
      setPhase("done");
      sessionStorage.setItem("hb_intro_shown", "1");
    }, 2400);

    return () => { clearTimeout(t0); clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (phase === "done") return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        background: "#0b0c0e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "24px",
        opacity: phase === "out" ? 0 : 1,
        transition: phase === "out" ? "opacity 0.6s cubic-bezier(0.4,0,0.2,1)" : "none",
        pointerEvents: phase === "out" ? "none" : "auto",
      }}
    >
      <img
        src="/logo-white-yellow.png"
        alt="Holzbuddy"
        style={{
          width: "220px",
          maxWidth: "55vw",
          opacity: phase === "in" || phase === "out" ? 1 : 0,
          transform: phase === "in" || phase === "out" ? "scale(1) translateY(0)" : "scale(0.9) translateY(8px)",
          transition: "opacity 0.8s cubic-bezier(0.4,0,0.2,1), transform 0.8s cubic-bezier(0.4,0,0.2,1)",
        }}
      />
      <div
        style={{
          width: "32px",
          height: "2px",
          background: "#f5c800",
          opacity: phase === "in" ? 1 : 0,
          transform: phase === "in" ? "scaleX(1)" : "scaleX(0)",
          transformOrigin: "left",
          transition: "opacity 0.4s ease 0.6s, transform 0.6s cubic-bezier(0.4,0,0.2,1) 0.6s",
        }}
      />
    </div>
  );
}
